export const ACCOUNT_CONTAINER_TAG_NAME = 'account-container';
